import { getMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Lists
export const GET_COUPON_LIST = 'GET_COUPON_LIST';
export const GET_COUPON_LIST_SUCCESS = 'GET_COUPON_LIST_SUCCESS';
export const GET_COUPON_LIST_FAILURE = 'GET_COUPON_LIST_FAILURE';

// Action Creators
export const fetchGetCouponList = () => ({
  type: GET_COUPON_LIST,
});

export const fetchGetCouponListSuccess = (data) => ({
  type: GET_COUPON_LIST_SUCCESS,
  payload: data,
});

export const fetchGetCouponListFailure = (error) => ({
  type: GET_COUPON_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getCouponListCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchGetCouponList(data, external));
    try {
      const response = await getMethodWithToken(url.getCouponListSuperAdmin);
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetCouponListSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetCouponListFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetCouponListFailure(error.message));
    }
  };
};
